var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapBox"},[_c('v-comMap'),_c('div',{staticClass:"control"},[_c('v-switchLayer')],1),_c('div',{staticClass:"planLayercontrol"},[(_vm.$route.path == '/index/planManage')?_c('v-planrele',{attrs:{"infoData":_vm.infoData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }